// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EstadosInformeFilterMultiSelect_autocomplete-style__3Tm-C{width:300}`, "",{"version":3,"sources":["webpack://./src/components/EstadosInformeFilterMultiSelect/EstadosInformeFilterMultiSelect.module.scss"],"names":[],"mappings":"AAAA,2DACE,SAAA","sourcesContent":[".autocomplete-style {\n  width: 300;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"autocomplete-style": `EstadosInformeFilterMultiSelect_autocomplete-style__3Tm-C`
};
export default ___CSS_LOADER_EXPORT___;
